<template>
    <span>
          <v-btn icon class="mx-0" @click="deleteCampus()">
                      <v-icon color="pink">delete</v-icon>
          </v-btn>  
        </span>
</template>

<script>
import {deleteSubModule} from '@/model';

export default {
    name: 'RemoveMovie',
    props:{
        name :{
            required:true
        },
        campus :{
            required:true
        }
    },
    data() {
        return {
           
         
        };
    },
    methods: {
        deleteCampus() {
            let self=this;
            let confirmed =  confirm('Warning!!! \n This will unlink this movie from this campus, do you continue?','Exodus','Yes','No');
    
            if(confirmed){
            deleteSubModule('campus',this.campus,this.name,function(response){
              if(response.value === true){
                  console.log("This is response: ",response);
                      alert('Movie has been unlinked successfully');
                      self.$store.dispatch('updateLinkedMovies',self.campus);
                    self.isDisabled = false; 
                  }else{
                      alert(response.err);
                      
                      console.log(null);
                  }

              });

                          }
        }
    }
};
</script>

<style scoped>
</style>